<ng-container *ngIf="isLoaded">
    <mc-tabs #tabs [tabs]='symbolEditorTabs'>
        <div slot="tab_1" *ngIf="pointSymbol">
            <slot name="point-symbol-editor" #pointSymbolEditor></slot>
        </div>
        <div slot="tab_2" *ngIf="lineSymbol">
            <slot name="line-symbol-editor" #lineSymbolEditor></slot>
        </div>
        <div slot="tab_3" *ngIf="polygonSymbol">
            <slot name="polygon-symbol-editor" #polygonSymbolEditor></slot>
        </div>
        <div slot="tab_4" *ngIf="textSymbol">
            <slot name="text-symbol-editor" #textSymbolEditor></slot>
        </div>
        <div slot="tab_5" *ngIf="heatmapRenderer">
            <slot name="heatmap-editor" #heatmapEditor></slot>
        </div>
    </mc-tabs>

    <!-- Previous implementation with Kendo controls used same slot name for all opacity control within each tab. -->
    <!-- When switching to mc-tabs component, this no longer worked if there were multiple tabs; only the first opacity control would display (slot name must be unique or first instance is used). -->
    <!-- Currently, all usages of this component utilize opacity for each tab and value is shared across tabs so a single slot outside tabs for component is valid. -->
    <slot name="layer-opacity-editor" #opacityEditor></slot>
</ng-container>

<div class="text-right">
    <button type="button" class="btn" (click)="apply()">OK</button>
    <button type="button" class="btn btn-clear" (click)="cancel()">Cancel</button>
</div>
